import { Component, Input, OnInit } from '@angular/core';
import { BlacklistFormGroup } from './blacklist-form-type';
import { BlacklistLicensePlateDTO, ControlPlateType } from 'src/app/base/models/models.swagger.generated';
import { DropDownConstantsFactory } from 'src/app/base/shared/syncfusion/dropdown-constants-factory';
import { DropDownItem } from 'src/app/base/shared/drop-down-item.model';
import { EnumTranslationService } from 'src/app/base/services/enum-translation.service';
import { CountryISO2 } from 'src/app/base/shared/countryISO2-enum';
import { ReactiveFormsModule } from '@angular/forms';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { EnumDropDownListComponent } from 'src/app/base/shared/enum-drop-down-list/enum-drop-down-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { MessageModule } from '@syncfusion/ej2-angular-notifications';

@Component({
    selector: 'app-blacklist-form',
    templateUrl: './blacklist-form.component.html',
    styleUrls: ['./blacklist-form.component.scss'],
    imports: [
        ReactiveFormsModule,
        AppErrorMessagesComponent,
        DropDownListModule,
        EnumDropDownListComponent,
        TranslateModule,
        MessageModule
    ]
})
export class BlacklistFormComponent implements OnInit {

  @Input() blacklistForm: BlacklistFormGroup;

  public enumDropdownSettings = DropDownConstantsFactory.createEnumDropdownSettings();
  public countryList: DropDownItem[];
  public ControlPlateType = ControlPlateType;

  public get isAdd(): boolean {
    return !this.blacklistForm.value.id;
  }

  constructor(
    private enumTranslationService: EnumTranslationService,
  ) { }

  ngOnInit() {
    this.countryList = this.enumTranslationService.translateEnum(CountryISO2, 'i18n.shared.CountryISO2.');
  }

}
